module.exports = __webpack_public_path__ + "img/ico-list-active.e3d8d6b7.svg";